export default {
  /**
   * 期間条件標準フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と日付を保持します。
   * 期間の種別が週や月であっても、最終的な日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 日
       */
      date: undefined,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    return {
      date: term.date,
    }
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, term) {
    applyTo.termType = term.termType
    applyTo.date = term.date
  },
}
